import React from 'react';

import { LAYOUT_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';

import { WelcomeScreen as WelcomeG12 } from './WelcomeG12/WelcomeScreen';
import { WelcomeScreen as WelcomeG15 } from './WelcomeG15/WelcomeScreen';
import { WelcomeScreen as WelcomeG3 } from './WelcomeG3/WelcomeScreen';
import { WelcomeScreen as WelcomeG5 } from './WelcomeG5/WelcomeScreen';
import { WelcomeScreen as WelcomeG6 } from './WelcomeG6/WelcomeScreen';
import { WelcomeScreen as WelcomeG9 } from './WelcomeG9/WelcomeScreen';

export const DynamicWelcomeScreen: React.FC = () => {
  const layoutNotes = webCampaign.getLayoutNotes();

  const getWelcomeComponent = () => {
    if (layoutNotes.includes(LAYOUT_NOTES.WelcomeG3)) {
      return WelcomeG3;
    }
    if (layoutNotes.includes(LAYOUT_NOTES.WelcomeG5)) {
      return WelcomeG5;
    }
    if (layoutNotes.includes(LAYOUT_NOTES.WelcomeG6)) {
      return WelcomeG6;
    }
    if (layoutNotes.includes(LAYOUT_NOTES.WelcomeG9)) {
      return WelcomeG9;
    }
    if (layoutNotes.includes(LAYOUT_NOTES.WelcomeG12)) {
      return WelcomeG12;
    }
    if (layoutNotes.includes(LAYOUT_NOTES.WelcomeG15)) {
      return WelcomeG15;
    }

    return WelcomeG3;
  };

  const WelcomeComponent = getWelcomeComponent();

  return <WelcomeComponent />;
};
